/**
 * @flow
 */

import { connect } from 'react-redux';
import { setDate } from '../../../../actions/schedule';
import { DatePicker } from '../../../../components';

const mapStateToProps = ({ schedule }) => ({
    value: schedule.get('date'),
    dayPickerProps: {
        defaultMonth: schedule.get('date'),
        selected: schedule.get('date'),
        mode: 'single',
    },
});

export default connect(mapStateToProps, { onChange: setDate })(DatePicker);
